"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Time {
    constructor(hours, minutes, seconds, ampm) {
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
        this.ampm = ampm;
    }
    isEqual(anotherTime) {
        return anotherTime && this.hours === anotherTime.hours &&
            this.minutes === anotherTime.minutes &&
            this.seconds === anotherTime.seconds &&
            this.ampm === anotherTime.ampm;
    }
}
exports.default = Time;
